import { useLocation, useSearchParams } from "react-router-dom";

import { ClimateActionListConfigurationView } from "@/domain/climate-action/components/climate-action-list-overview/climate-action-list-configuration-pane-view";
import { ClimateActionListFilterView } from "@/domain/climate-action/components/climate-action-list-overview/climate-action-list-filter-pane-view";
import { ClimateActionListOverview } from "@/domain/climate-action/components/climate-action-list-overview/climate-action-list-overview";
import { ClimateActionListProviderStackInitializer } from "@/domain/climate-action/components/climate-action-list-overview/utils/climate-action-list-provider-stack-initializer";
import { useCurrentClimateActionListContext } from "@/domain/climate-action/hooks/use-current-climate-action-list-context";
import { useCurrentUserContext } from "@/domain/user/hooks/use-current-user-context";
import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";

import { useTableConfigurationFocusAreaPage } from "../use-table-configuration-for-focus-area-page";

export const FocusAreaClimateActionListAllPage = () => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();

  const { currentUser } = useCurrentUserContext();
  const { currentWorkspace } = useCurrentWorkspaceContext();
  const { currentClimateActionList } = useCurrentClimateActionListContext();

  const tableConfiguration = useTableConfigurationFocusAreaPage({
    workspace: currentWorkspace,
  });

  return (
    <ClimateActionListProviderStackInitializer
      pathname={pathname}
      searchParams={searchParams}
      workspace={currentWorkspace}
      user={currentUser}
      climateActionList={currentClimateActionList}
      config={tableConfiguration}
    >
      <div className="flex h-full max-h-full flex-col overflow-y-hidden">
        <ClimateActionListConfigurationView />
        <ClimateActionListFilterView />
        <ClimateActionListOverview />
      </div>
    </ClimateActionListProviderStackInitializer>
  );
};
